var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Your MLS Number"}},[_c('input-text',{staticClass:"w-full md:w-2/5",attrs:{"name":"mls_number","value":_vm.settings.mls_number,"placeholder":"#"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }